module.exports = __webpack_public_path__ + "img/41.33669393.jpg";